import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const TenantCtx = createContext(null);
export const useTenant = () => useContext(TenantCtx);

const readableOn = (hex) => {
  const m = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex || "");
  if (!m) return "#fff";
  const [r, g, b] = [m[1], m[2], m[3]].map((h) => parseInt(h, 16));
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6 ? "#0F1725" : "#fff";
};

export function TenantProvider({ children }) {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/company/config");
      setCompany(data);
      const accent = data.accent_color || "#FFA502";
      document.documentElement.style.setProperty("--client-accent", accent);
      document.documentElement.style.setProperty("--client-accent-hover", accent);
      document.documentElement.style.setProperty("--client-accent-text", readableOn(accent));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <TenantCtx.Provider value={{ company, loading, reload: load }}>
      {children}
    </TenantCtx.Provider>
  );
}
